import {
  SimpleLineChart,
  StackedBarChart,
  StackedBarLineChart,
  WaterfallChart,
} from '../../components/charts';
import type { CategoryData } from '../../components/charts/WaterfallChart';
import type { SimpleLineChartDataPoint } from '../../components/charts/SimpleLineChart';
import { ChartCard, LoadingState } from '../../components/ui';
import { DEFAULT_LINE_COLOR, type StatementType } from './financialStatements.config';

interface StatementTopChartProps {
  statementType: StatementType;
  currencyCode: string;
  topTitle: string;
  lineChartData: SimpleLineChartDataPoint[];
  lineChartLoading: boolean;
  lineYAxisLabel: string;
  assetsWaterfallData: CategoryData[];
  balanceWaterfallLoading: boolean;
  incomeNOIChartData: {
    xLabels: string[];
    stacks: Parameters<typeof StackedBarLineChart>[0]['stacks'];
    lineSeries: Parameters<typeof StackedBarLineChart>[0]['lineSeries'];
  } | null;
  filteredStatementData: Map<number, Map<string, number>> | null;
}

export function StatementTopChart({
  statementType,
  currencyCode,
  topTitle,
  lineChartData,
  lineChartLoading,
  lineYAxisLabel,
  assetsWaterfallData,
  balanceWaterfallLoading,
  incomeNOIChartData,
  filteredStatementData,
}: StatementTopChartProps) {
  return (
    <ChartCard title={topTitle} className="fs-layout__top-chart fs-chart-card">
      {statementType === 'balance' ? (
        balanceWaterfallLoading ? (
          <LoadingState message="Loading assets data…" />
        ) : (
          <WaterfallChart
            data={assetsWaterfallData}
            title=""
            height="100%"
            width="100%"
            currencyCode={currencyCode}
            className="fs-chart-panel"
          />
        )
      ) : statementType === 'income' && incomeNOIChartData ? (
        <StackedBarLineChart
          xLabels={incomeNOIChartData.xLabels}
          stacks={incomeNOIChartData.stacks}
          lineSeries={incomeNOIChartData.lineSeries}
          xAxisLabel=""
          yAxisLabel=""
          maxXTicks={8}
          height="100%"
          width="100%"
          loading={filteredStatementData === null}
          currencyCode={currencyCode}
          className="fs-chart-panel"
        />
      ) : (
        <SimpleLineChart
          data={lineChartData}
          title=""
          xAxisLabel="Date"
          yAxisLabel={lineYAxisLabel}
          lineColor={DEFAULT_LINE_COLOR}
          showMarkers
          showGrid
          height="100%"
          width="100%"
          loading={lineChartLoading}
          markerSize={4}
          currencyCode={currencyCode}
          className="fs-chart-panel"
        />
      )}
    </ChartCard>
  );
}
